import React from 'react'
import CheckBlue from '../../../../media/images/check-blue.svg'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import Check from '../../../../media/images/check.svg'

export default function FullWidthCard({
  id,
  title,
  type,
  category,
  image,
  benefits,
  showCategories,
  downloaded,
}: any) {
  const {formatMessage} = useIntl()
  const hrefValue = type === 'resources' ? `/resources/documents/${id}` : '#'
  return (
    <div className='mb-4 rounded-2'>
      <div className='p-0'>
        <div className='d-flex flex-column justify-content-between flex-md-row align-items-center'>
          <div className='documents-card-v2 flex-grow-1 bg-white w-100'>
            <div className={`d-flex flex-column flex-md-row justify-self-start cardLayout`}>
              <Link to={hrefValue} aria-disabled={type !== 'resources'} className='doc-image'>
                <img src={image} alt='documents thumbnail' className={`d-flex `} />
              </Link>
              <div className='d-flex flex-column w-100 p-4 justify-content-between'>
                <div className='d-flex flex-column'>
                  <div className='d-flex justify-content-between align-items-center mb-4'>
                    <p
                      className='px-4 py-1 font-size-14 mb-0'
                      style={{borderRadius: '80px', border: '1px solid #CFE0FA'}}
                    >
                      {category}
                    </p>
                    <button className='border-0 bg-transparent'>
                      {downloaded && <img src={Check} alt='check' />}
                    </button>
                  </div>

                  <h5 className='font-size-16 d-flex align-items-center gap-2'>
                    {title}
                    <span
                      className='font-size-12 font-weight-400'
                      style={{
                        color: '#50cd89',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        background: '#e8fff3',
                      }}
                    >
                      1.0
                    </span>
                  </h5>

                  <ul className='list-unstyled mt-4'>
                    {benefits
                      .slice(0, 3)
                      .map(
                        (
                          feature:
                            | boolean
                            | React.ReactChild
                            | React.ReactFragment
                            | React.ReactPortal
                            | null
                            | undefined,
                          i: React.Key | null | undefined
                        ) => (
                          <li key={i} className='mb-2 font-size-13 d-flex align-items-center gap-2'>
                            <img src={CheckBlue} alt='' />
                            {feature}
                          </li>
                        )
                      )}
                  </ul>
                </div>
                <div className='d-flex justify-content-end'>
                  <Link
                    to={hrefValue}
                    aria-disabled={type !== 'resources'}
                    className='btn btn-primary cta-documents'
                  >
                    {formatMessage({id: 'Know More'})}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
